import parse from "html-react-parser";
import React, { useEffect, useRef, useState } from "preact/compat";
import SlideshowSlick from "../../../SlideshowSlick";
import { getItem, setItem } from "../../../utils/storage";
import VideoPlayer from "../Utils/VideoPlayer";

const SmartHtmlContainer = ({ area, onEvent, idStorage, isHidden, flow, isUniq, company }) => {
  const [currentFrame, setCurrentFrame] = useState(getItem(idStorage) ?? 0);
  const [currentSlide, setCurrentSlide] = useState(getItem(idStorage) ?? 0);
  const [isEnding, setIsEnding] = useState(false);
  const [videoHasError, setVideoHasError] = useState(false);
  const [isPlaying, setIsPlaying] = useState(true);
  const [videoDuration, setVideoDuration] = useState(null);
  const [slides, setSlides] = useState([]);
  const current_data = area?.data[0] || area?.data;
  const [html, setHtml] = useState(current_data?.frameContent?.html || current_data?.html);
  const [displayVideo, setDisplayVideo] = useState(false);
  const playerRef = useRef(null);

  useEffect(() => {
    setHtml(current_data?.frameContent?.html || current_data?.html);
  }, [current_data?.frameContent?.html, current_data?.html]);

  useEffect(() => {
    if (!isHidden) {
      if (videoHasError && !isEnding) {
        setVideoHasError(false);
        setIsEnding(true);
        setTimeout(() => onEvent('end'), 5000);
      }

      setIsPlaying(true);
      setIsEnding(false);
      const frame_count = !isUniq ? flow.endOn.frame_count : current_data?.medias?.length;
      const medias = current_data?.medias;
      let filteredSlides = medias || [];

      if (flow.endOn?.type === 'frame_count' && medias && medias.length) {
        filteredSlides = medias.slice(currentFrame, currentFrame + frame_count - 1);

        if (filteredSlides.length < frame_count && medias.length > frame_count) {
          const addedSlides = medias.slice(0, frame_count - filteredSlides.length);
          filteredSlides = [...filteredSlides, ...addedSlides];
        }
      }

      setSlides(filteredSlides);
    } else {
      setDisplayVideo(false);
      playerRef?.current?.seekTo(0);
    }

    return () => setCurrentSlide(0);
  }, [currentFrame, isEnding, videoHasError, playerRef, flow, isHidden]);

  useEffect(() => {
    const endEvent = () => {
      onEvent('end')
    }

    if (isEnding) {
     setTimeout(endEvent, 2000)
    }

    return () => clearTimeout(endEvent)
  }, [isEnding])

  const options = {
    replace: ({ attribs }) => {
      if (!attribs) {
        return;
      }

      if (attribs.class === '__videoplayer__' && attribs["data-video"]) {
        return (<div style={{ backgroundColor: '#000', position: 'absolute', top: 0, left: 0 }}>
          <div style={{ opacity: 1, transition: 'opacity 500ms ease-out' }}>
            <VideoPlayer
              ref={playerRef}
              key={`player_${area.id}`}
              id={`player_${area.id}`}
              lineColor={company?.extraData?.mainColor || "#EA387C"}
              progressBar
              url={attribs["data-video"]}
              isPlaying={isPlaying}
              setVideoDuration={(duration) => setVideoDuration(duration)}
              isUniq={isUniq}
              onEnded={() => {
                if (!isEnding) {
                  setIsEnding(true);
                }
              }}
              onError={() => {
                setVideoHasError(true);
              }}
              onProgress={(dataPlaying) => {
                if (dataPlaying.playedSeconds > 0 && !isHidden && !displayVideo) {
                  setDisplayVideo(true);
                }

                if (dataPlaying.playedSeconds > 0 && isHidden && isPlaying) {
                  // setIsPlaying(false);
                }

                if (dataPlaying.playedSeconds >= videoDuration - 1 && videoDuration && !isEnding) {
                  setIsEnding(true);
                }
              }}
            />
          </div>
        </div>);
      } else if (attribs.class === '__slider__' && slides?.length) {
        const initialDelay = (area?.widget?.config?.slide_time ?? 25) * 1000;

        return (
          <SlideshowSlick
            areaId={`${area.id}_${currentFrame}`}
            infinite={isUniq}
            lazyLoad='ondemand'
            fade={true}
            slides={slides}
            mode={'html'}
            initialSlide={currentSlide}
            onEnd={() => {
              setCurrentFrame(currentFrame + 1);
              setItem(idStorage, 0);
              onEvent("end");
            }}
            onEvent={(eventType, data) => {
              if (eventType === "slideChange") {
                setItem(idStorage, data.slideIndex);
                onEvent("updateFrame");
              }

              onEvent(eventType, data);
            }}
            delay={initialDelay}
            isHidden={isHidden}
          />
        );
      }
    }
  };

  return (<div style={{ height: '100%', width: '100%' }} className={!isHidden ? 'has-animations' : ''}>{parse(html ?? "", options)}</div>)
}

export default React.memo(SmartHtmlContainer, (props, nextProps) => {
  return props.area?.id === nextProps.area?.id && props.isHidden === nextProps.isHidden && props.area?.uniqId === nextProps.area?.uniqId;
})
